import React from 'react';

import { OneTimeLinkUpload } from '@/modules/transaction/components/TransactionDetails/OneTimeLinkUpload';

const OneTimeLinkUploadPage = () => (
  <OneTimeLinkUpload />
);

export default OneTimeLinkUploadPage;
